import { Box, ListRow, Text, Tooltip } from '@betterment/samba-react';
import { useFallbackKeys } from '@betterment/shared-components/src/hooks/useFallbackKeys';

import { TradeRow } from './TradeRow';

import { TradeItem } from '../../transactionTypes/Trade';
import { TransferItem } from '../../transactionTypes/Transfer';

type TradeRowItem = TransferItem | TradeItem;

interface TradesListProps {
  items?: TradeRowItem[];
  title?: string;
  subTitle?: string;
  toolTipMessage?: string;
}

export const TradesList: React.FC<React.PropsWithChildren<TradesListProps>> = ({
  items,
  title,
  subTitle,
  toolTipMessage,
}) => {
  const trades = useFallbackKeys(items || []);
  return (
    <Box css={{ py: 'space.200', display: 'flex', flexDirection: 'column', gap: 'space.300' }}>
      <ListRow css={{ p: 0 }}>
        <ListRow.LeadingContent>
          <Box css={{ display: 'flex', direction: 'row', gap: 'space.50' }}>
            <Text variant="text100">{title}</Text>
            {toolTipMessage && (
              <Tooltip>
                <Tooltip.Trigger asChild={true}>
                  <Tooltip.IconButton name="InfoCircle" css={{ cursor: 'default' }} />
                </Tooltip.Trigger>
                <Tooltip.Content align="start" side="bottom" css={{ zIndex: '400' }}>
                  {toolTipMessage}
                </Tooltip.Content>
              </Tooltip>
            )}
          </Box>
        </ListRow.LeadingContent>
        <ListRow.TrailingContent>
          <Text variant="text100"> {subTitle} </Text>
        </ListRow.TrailingContent>
      </ListRow>
      <Box
        css={{
          display: 'flex',
          flexDirection: 'column',
          gap: 'space.400',
          backgroundColor: 'background.overlay.weak',
          padding: 'space.200',
          borderRadius: 'medium',
        }}
      >
        {trades?.map(({ item, key }) => (
          <TradeRow key={key} item={item} />
        ))}
      </Box>
    </Box>
  );
};
